var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdVerificationBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.5007C25 25.0007 19.75 28.7507 13.51 30.9257C13.1832 31.0364 12.8283 31.0311 12.505 30.9107C6.25 28.7507 1 25.0007 1 17.5007V7.00067C1 6.60285 1.15804 6.22132 1.43934 5.94001C1.72064 5.65871 2.10218 5.50067 2.5 5.50067C5.5 5.50067 9.25 3.70067 11.86 1.42067C12.1778 1.14917 12.582 1 13 1C13.418 1 13.8222 1.14917 14.14 1.42067C16.765 3.71567 20.5 5.50067 23.5 5.50067C23.8978 5.50067 24.2794 5.65871 24.5607 5.94001C24.842 6.22132 25 6.60285 25 7.00067V17.5007Z",
    fill: "#FDECE9",
    stroke: "#ED6E5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.0006L11.5 19.0006L17.5 13.0006",
    stroke: "#ED6E5C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdVerificationBadge);
export default __webpack_public_path__ + "static/media/id-verification-badge.3af20ef9819fee5ac35494c8364b2d8e.svg";
export { ForwardRef as ReactComponent };